window.burgon = window.burgon || {};

var template = "";
var session_type = "customer";
var isCustomer = false;
var shop_domain = "";

burgon.Settings = function(options) {
    template = options.template,
    session_type = options.session_type,
    isCustomer = options.isCustomer,
    shop_domain = "https://" + options.shop_domain
}

burgon.init = function() {
    burgon.customSessions();
    burgon.sharesChecker();
    burgon.modalPopup();
    burgon.lazyLoader();
    burgon.productPage();
    burgon.miniCart();

    console.log('reqaccount:: ' + template);

    if (template == 'article') {
        burgon.articlePage();
    }

    if (template == 'cart') {
        burgon.ajaxPriceRefresh();
    }

    if (template == 'page.trader-request-new') {
        burgon.requestTradeAccount();
    }

    if (window.location.href.indexOf("store-locator") > -1) {
      console.log("currently in the store locator page");
      burgon.storeLocator();
    }

    console.log("User template: " + template);
    console.log("Is user logged in: " + isCustomer);
    console.log("Is this trade user: " + session_type);
};

burgon.isTradeSession = function() {
    return session_type == "trade";
};

burgon.customSessions = function() {
    // creating a cookie if the user clicks on the trade button

    setTimeout(function() {
      $('.main-content').css({'opacity': 1});
    }, 500);

    if (template == "index" && session_type == "trade") {
      window.location.href = '/pages/trade';
    }

    $("html").on("click", '.action__trade-site, .action__customer-site', function(event) {
      event.preventDefault();
      var val = $(this).data("session-type");
      if (val == 'trade') {
        $(this).text('Loading Trade Site');
      } else {
        $(this).text('Going Back to Consumer Site');
      }



        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          data: {},
          dataType: 'json',
          success: function(d) {
            console.log('cart emptied');
            // var request = new XMLHttpRequest();
            // request.open('POST', '/cart.js', true);
            // request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            // request.send( {"attributes[session-type]": val} );

            // alert('Hello there! How do you do?');
            //
            // setTimeout(function() {
            //   console.log('about to redirect to homepage');
            //   if (val == 'trade') {
            //     window.location.replace(shop_domain + '/pages/trade');
            //   } else {
            //     window.location.replace(shop_domain);
            //   }
            // }, 1000);


              $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: { "attributes[session-type]": val },
                dataType: 'json',
                success: function(b) {
                  // console.log('HELLO OTHER m8');
                    if (val == 'trade') {
                      window.location.href = '/pages/trade';
                    } else {
                      window.location.href = shop_domain;
                    }
                }
              });
          }
        });

    });

    if (template == "product.trade" && session_type != "trade") {
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: { "attributes[session-type]": "trade" },
        success: function(d) {
          // window.location.reload();
          window.location.reload();
        },
        dataType: 'json'
      });
    }


    if (template == "page.trade-homepage" && session_type != "trade") {
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: { "attributes[session-type]": "trade" },
        success: function(d) {
          // window.location.reload();
          window.location.reload();
        },
        dataType: 'json'
      });
    }

}

burgon.giftWrapping = {};

burgon.giftWrapping.add = function() {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    // data: { updates: { 41114433164: 1 }, attributes: { 'gift-remove-prices': true } },
    data: { note: "Gift (remove prices)", attributes: { 'gift-remove-prices': true } },
    dataType: 'json',
    success: function() { console.log('gift wrapping product added'); }
  });
}

burgon.giftWrapping.remove = function() {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    // data: { updates: { 41114433164: 0 }, attributes: { 'gift-remove-prices': '' } },
    data: { note: "Gift (remove prices)", attributes: { 'gift-remove-prices': '' } },
    dataType: 'json',
    success: function() { console.log('gift wrapping product removed'); }
  });
}

burgon.giftWrapping.checkForProductAjax = function() {
  var check_product = false;
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {
      handleData(data);
    }
  });

  function handleData(data) {
    check_product = data.attributes['gift-remove-prices'];
    if (check_product == 'true') {
      $('#Ajaxcart_Wrap-option-checkbox').prop('checked', true);
    } else {
      $('#Ajaxcart_Wrap-option-checkbox').prop('checked', false);
    }
  }
}

burgon.giftWrapping.checkForProduct = function() {
  var check_product = false;
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {
      handleData(data);
    }
  });

  function handleData(data) {
    check_product = data.attributes['gift-remove-prices'];
    if (check_product == 'true') {
      $('#CartGift').prop('checked', true);
    } else {
      $('#CartGift').prop('checked', false);
    }
  }

  $('.cart__gift-wrapper').on('change', '#CartGift', function() {
    var gift_wrap_cart_checkbox_status = $('#CartGift').is(':checked');
    console.log('Box in cart clicked with status: ' + gift_wrap_cart_checkbox_status);
    if (gift_wrap_cart_checkbox_status) {
      burgon.giftWrapping.add();
    } else {
      burgon.giftWrapping.remove();
    }
  });
}

burgon.collectionPages = function(options) {
  selector = options.selector;
  console.log('collectionPages method ready!');

  var minimized_elements = $(selector);

  minimized_elements.each(function(){
      var t = $(this).html();
      if(t.length < 190) return;

      $(this).html(
          t.slice(0, 190)+'<span class="more__content_dots">... </span><a href="#" class="show__more">Read more</a>'+
          '<div class="more__content" style="display:none;">'+ t.slice(190,t.length)+' <a href="#" class="show__less">Show less</a></div>'
      );

  });

  $('a.show__more', minimized_elements).click(function(event){
      event.preventDefault();
      $(this).hide().prev().hide();
      $(selector).find('.more__content').css("display", "inline");
      $('.collection_header-info_container').addClass('collection_header__expanded').find(selector).hide().fadeIn('slow', function() {});
  });

  $('a.show__less', minimized_elements).click(function(event) {
      event.preventDefault();
      // $(this).parent().hide().prev().css("display", "inline").prev().css("display", "inline");
      $(this).parent().hide();
      $(selector).find('.more__content_dots').css('display', 'inline').parent().find('.show__more').css('display', 'block');
      $('.collection_header-info_container').removeClass('collection_header__expanded');
  });
}

burgon.improvedCollectionPages = function(options) {
  selector = options.selector;
  console.log('improvedCollectionPages method ready!');

  $('a.show__more').click(function(event) {
    event.preventDefault();
    $('.collection__excerpt-desc').hide();
    $('.collection_header-info_container').addClass('collection_header__expanded');
    $('.collection__full-description').delay(500).fadeIn('slow', function() {});
  });

  $('a.show__less').click(function(event) {
    event.preventDefault();
    $('.collection__full-description').hide();
    $('.collection_header-info_container').removeClass('collection_header__expanded');
    $('.collection__excerpt-desc').fadeIn('slow', function() {});
  });

}

burgon.productPage = function() {
  if(session_type == "trade"){
    //remove prices
    // $(".product-button-box").remove();
    // $(".product-info_form-price").remove();
    // $(".product-info_login-links").show();
  }
  return true;
}

burgon.articlePage = function() {
  $('.article__main-content__body img').each(function(index, el) {
    var get_img_style = $(this).attr('style');
    var get_img_alt = $(this).attr('alt');

    $(this).wrap('<div class="article__image-block article__image-block-body-rte"></div>');
    if (get_img_alt != "") {
      $(this).parent().append('<div>' + get_img_alt + '</div>').attr('style', get_img_style);
    } else {
      $(this).parent().attr('style', get_img_style);
    }

    console.log(get_img_alt);
    console.log(get_img_style);
  });
  // $('.article__main-content__body').find('img').wrap('<div class="article__image-block article__image-block-body"></div>');
  // $('.article__image-block-body').append('<div>Testing the alt label</div>');
  // TODO: Get img style attributes to the parent div
  // TODO: Get alt data and append to div
}

//checks for facebook+pinterest shares number
burgon.sharesChecker = function(){
    if($(".share-request-element").size() > 0){
        $(".share-request-element").each(function(i,elem){
            var item = {};
            item.cURL = $(elem).data("url");
            item.pinterest = 0;
            item.facebook = 0;
            //console.log(i+" "+item.cURL);
            $.ajax({
                url:"http://graph.facebook.com/?id="+item.cURL,
                success: function(res){
                    item.facebook = res.share.share_count;
                    $.ajax({
                        dataType: "text",
                        url:"http://api.pinterest.com/v1/urls/count.json?callback=receiveCount&url="+item.cURL,
                        success: function(res){
                            res = res.replace("receiveCount(", "").replace(")", "");
                            res = JSON.parse(res);
                            item.pinterest = res.count;
                            //console.log(parseInt(item.pinterest));
                            //console.log(parseInt(item.facebook));
                            $(elem).text(parseInt(item.pinterest)+parseInt(item.facebook));
                        },
                        error: function(jqXHR, textStatus){
                            console.log("Pinterest error "+textStatus);
                        }
                    });
                },
                error:function(jqXHR, textStatus){
                    console.log("Facebook error "+textStatus);
                }
            });
        });
    }
}

burgon.storeLocator = function() {
  console.log('in the store locator object');
  $('#col-main').wrap('<div class="wrapper store--app-page"></div>');
  $('#col-main').prepend('<div class="page-header" style="margin-top: 20px;"></div>');
  $('.page-header').append('<h1>Stockists</h1><div class="page-header__description wider-description">Our products are available in thousands of places around the world. Here you can find the Burgon & Ball closest to you. If you know a place where you would like to see our products, please tell them - or <a href="mailto:sales@burgonandball.com"><u>tell us</u></a>! <br><br>To find your nearest Burgon & Ball stockist, simply enter your postcode below. Results can be filtered by ‘Tools’ or ‘Gifts’. The Platinum stockist categories listed below carry a wider selection of products. <br><br>Please note: some stockists carry a limited range of products. To avoid disappointment, we recommend phoning your chosen stockist to check availability before travelling.</div>');
  $('#store-locator-title').hide();

  $('.search_bar').after("<div class='additional--description'></div>");

  var $el = $('.search_bar');
  $el.find('.search_limit').hide();
  var submit_button = $el.find('button');
  submit_button.wrap('<div class="custom_search_section"></div>');
  $('#address_search').detach().prependTo('.custom_search_section');
  // $el.find('#address_search').wrap('<div class="custom_search_field"></div>');
  // $('#custom_search_field').detach().insertBefore('button');
  // var submit_button = $('.search_bar button');
  // console.log(submit_button);
  // $('.search_bar button').detach().appendTo('#custom_search_field');

  // if(window.location.href.indexOf("store-locator") > -1) {
  //     $('.header_html').addClass('map-container');
  //     $('.map-container').wrap('<div class="contact-page wrapper extra padded-section"><div class="flex contact-flex"></div></div>');
  //     $('<div class="title-section"><h1 class="small-title">STOCKISTS</h1></div>').insertBefore('.map-container');
  //     $('h2:contains("STOCKISTS")').hide();
  //     $('#address_search').removeAttr('onfocus').attr('value', '').attr('placeholder', 'Enter Postcode or City');
  //     $('<span class="fa fa-search custom-search-fa"></span>').insertAfter('#address_search');
  // }
}

burgon.miniCart = function() {
  $('.js-drawer-open-right').on('click', function(event) {
    if(!$('html').hasClass('js-drawer-open-right')) {
      window.location.href = '/cart';
      // console.log('would try to redirect ...');
    }
  });
}

function ESCpopupElement(options){
    var self = this;
    console.log(options);
    this.headerContent = options.headerContent || "";
    this.footerContent = options.footerContent || "";
    this.body = options.body || "";
    this.trigger = options.trigger || "";
    this.target = options.target || "";
    this.closeTrigger = options.closeTrigger || ".ESCpopupCloseTrigger";

    //elements allocation
    var popupShield = $("<div>").addClass("ESCpopupShield");
    var popupBox = $("<div>").addClass("ESCpopupBox");
    var popupWrapper = $("<div>").addClass("ESCpopupWrapper");
    var popupClose = $("<div>").addClass("ESCpopupClose");
    var popupHeader = $("<div>").addClass("ESCpopupHeader");
    var popupBody = $("<div>").addClass("ESCpopupBody");
    var popupFooter = $("<div>").addClass("ESCpopupFooter");

    if(this.headerContent != ""){
        popupHeader.html(this.headerContent);
        popupWrapper.append(popupHeader);
    }
    if(this.headerContent != ""){
        popupHeader.html(this.headerContent);
        popupWrapper.append(popupHeader);
    }
    if(this.body != ""){
        popupBody.html(this.body);
        popupWrapper.append(popupBody);
    }
    if(this.footerContent != ""){
        popupFooter.html(this.footerContent);
        popupWrapper.append(popupFooter);
    }

    popupWrapper.append(popupClose);
    popupBox.append(popupWrapper);

    this.showPopup = function(){

        var siteSection = 'consumer';

        if ( $('body').hasClass('trade--active') ) {
            siteSection = 'trade';
        }

        var popupText = 'Do you really want to leave our ' + siteSection + ' website?';

        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(data) {
                console.log(data);

                if ( data.item_count > 0) {
                    popupText += ' You will lose the items you have placed in your barrow if you move to our consumer site';
                }

                $('p#popUpText').text(popupText);
            }
        });

        console.log("show the popup");
        $("body").addClass("popupOn");
        if (template == 'product') {
          $('.zoomContainer').addClass('force-to-hide');
        }
        popupShield.on("click", function(){
            self.killPopup();
        });
        popupClose.on("click", function(){
            self.killPopup();
        });
        popupWrapper.find(this.closeTrigger).on("click", function(e){
          e.preventDefault();
          self.killPopup();
        })

        $("body").append(popupShield);
        $("body").append(popupBox);
    }

    this.killPopup = function(){
        console.log("kill popup");
        popupShield.off();
        popupShield.remove();
        popupBox.remove();
        $("body").removeClass("popupOn");
        if (template == 'product') {
          $('.zoomContainer').removeClass('force-to-hide');
        }
    }

    this.toString = function(){
        console.log(self.headerContent);
        console.log(self.footerContent);
        console.log(self.body);
        console.log(self.trigger);
        console.log(self.target);
    }
}

burgon.modalPopup = function(){

    var popup = {};

    console.log("call");

    $(".ESCpopupTrigger").each(function(i, elem){
        $trigger = $(elem);
        var trigger_target_string = $trigger.data("target");
        //console.log("init thing: " + trigger_target_string);
        if($("."+trigger_target_string).size() > 0){
            $trigger.on("click", function(e){
                e.preventDefault();
                $target = $("."+trigger_target_string);
                $target.header = $target.find(".ESCpopupContent__header").html();
                $target.body = $target.find(".ESCpopupContent__body").html();
                //console.log("read thing: " + $target.body);
                $target.footer = $target.find(".ESCpopupContent__footer").html();
                //example data
                var opt = {};
                opt.target = $target;
                opt.trigger = $trigger;
                if($target.header != "") opt.headerContent = $target.header;
                if($target.body != "") opt.body = $target.body;
                if($target.footer != "") opt.footerContent = $target.footer;
                popup = new ESCpopupElement(opt);
                //output test
                //popup.toString();
                popup.showPopup();
            });
        }
        else console.log("Can't find any "+trigger_target_string+" element");
    });

}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function ESClazyLoader(options){
    var self = this;
    self.async = options.async || true;
    self.page = options.page || 1;
    self.totalPages = options.totalPage || 1;
    self.url = options.url || "/";
    self.selector = options.selector || ".element";
    self.target = options.target || ".container";
    //not used yet
    self.type = options.type || "product";

    self.loadPage = function(successCallback, completeCallback){
        if(self.page < self.totalPages){
            self.page++;
            console.log(self);

            $.ajax({
                url: self.url+"?page="+self.page,
                async: self.async,
                success: function(data){
                    queryString.push("p", self.page);
                    content = $(data).find(self.selector);

                    if (content.length) {
                        $(self.target).append(content);
                    }

                    if(typeof(successCallback)==="function"){
                        successCallback();
                    }
                }, error: function(){
                    console.log("error");
                }, complete: function(){
                    if(self.page >= self.totalPages){
                        if(typeof(completeCallback)==="function"){
                            completeCallback();
                        }
                    }
                }
            });
        }
    };

}

burgon.lazyLoader = function(){
    var currentPage = getParameterByName("p") ? parseInt(getParameterByName("p")) : 1;
    var opt = {};
    opt.page = 1;
    opt.async = true;
    var lazyLoader = new ESClazyLoader(opt);
    if($(".ESClazyLoader").size() > 0){
        $(document).on("click", ".ESClazyLoader", function(e){
            e.preventDefault();
            var $self = $(this);
            lazyLoader.url = $self.data("url");
            lazyLoader.type = $self.data("type");
            lazyLoader.selector = $self.data("selector");
            lazyLoader.target = $self.data("target");
            lazyLoader.totalPages = $self.data("total_pages");

            $self.attr("disabled", "disabled");
            $self.html("Loading");
            lazyLoader.loadPage(function(){
                $self.attr("disabled", false);
                $self.text("Load more");
            },function(){
                $self.hide();
            });
            //console.log("async: "+lazyLoader.async);
        });
    }

    var recursiveClick = function(){
        if(currentPage == 1) return;
        currentPage--;
        $(".ESClazyLoader").click();
        recursiveClick();
    }

    if(currentPage > 1){
        lazyLoader.async = false;
        recursiveClick();
        lazyLoader.async = true;
    }
};

burgon.isInt = function(n) {
  if (n.indexOf('.')) {
    return false;
  } else {
    return n % 1 === 0;
  }
}

burgon.ajaxPriceRefresh = function(){
    var active_click = true;
    var total = 0;

    // Check if cart is more than £200
    var get_cart_total = parseFloat($('.cart__subtotal').data("val"));
    var checkout_button = $('.cart-checkout-btn');
    var checkout_button_disabled = $('.cart-checkout-btn-disabled');
    if (burgon.isTradeSession()) {
      console.log('Cart price: ' + get_cart_total + ' / Cart price parsed: ' + parseFloat(get_cart_total));
      if (get_cart_total >= 20000) {
        checkout_button.text('Checkout').attr("disabled", false).attr("href", "/pages/pre-checkout");
        checkout_button_disabled.hide();
        checkout_button.show();
      } else {
        checkout_button_disabled.show();
        checkout_button.hide().attr("disabled", "disabled").attr("href", "javascript: void(0)");
      }
    }

    //generic class name
    $(document).on("change", ".js-qty__num", function(e){
        e.preventDefault();



        if(active_click) {
            active_click = false;

            var self = $(this);
            var id = self.data("id");
            var value = self.val().replace(/\D/g, '');

            var product_data = {
              quantity: value,
              id: id
            }

            //add AJAX
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data:  product_data,
                dataType: 'json',
            }).success(function(cart) {
                total = cart.total_price;
                tradeTotal = 0;

                var number = cart.item_count;
                $.each(cart.items, function(key, prop){

                    if (burgon.isTradeSession()) {
                        // console.log(prop);
                        var tradePrice = prop.properties.trade_variant.price;
                        var tradePriceParse = 0;
                        if (burgon.isInt(tradePrice)) {
                          tradePriceParse = tradePrice;
                          console.log('In burgon.isInt(tradePrice)');
                        } else {
                          tradePriceParse = tradePrice.split('.').join('');
                          console.log('else burgon.isInt(tradePrice)');
                        }
                        var tradeLinePrice = tradePriceParse * prop.quantity;

                        console.log('Before math: ' + tradePriceParse + " / " + tradeLinePrice);

                        tradeTotal += parseInt(tradeLinePrice);

                        console.log('After math: ' + tradePriceParse + " / " + tradeLinePrice);

                        // var tradeLinePriceFormatted = Shopify.formatMoney(tradeLinePrice, '£');
                        console.log(prop.title, value, prop.quantity, tradePrice, tradeLinePrice, tradeTotal);
                        console.log('------------------');
                        if (prop.key == id) {
                          // $("#total_"+(id.replace(":", "\\:"))).text(tradeLinePrice);
                          $("#total_"+(id.replace(":", "\\:"))).text(Shopify.formatMoney(tradeLinePrice, '£'));
                        }
                        // tradeTotalFloated = parseFloat(tradeTotal/100).toFixed(2);
                        // $('.cart__subtotal').text(Shopify.formatMoney(tradeTotal.toFixed(2), '£'));

                        var parse_total_price = Shopify.formatMoney(tradeTotal, '£');

                        $('.cart__subtotal').text(parse_total_price);

                        var checkout_button = $('.cart-checkout-btn');

                        var checkout_button_disabled = $('.cart-checkout-btn-disabled');

                        console.log('Cart current amount: ' + tradeTotal);

                        if (tradeTotal >= 20000) {
                          checkout_button.text('Checkout').attr("disabled", false).attr("href", "/pages/pre-checkout");
                          checkout_button_disabled.hide();
                          checkout_button.show();
                        } else {
                          checkout_button_disabled.show();
                          checkout_button.hide().attr("disabled", "disabled").attr("href", "javascript: void(0)");
                        }


                        // debugger;
                    } else {
                        // console.log(prop.key+" "+id);
                        if(prop.key == id){
                            //console.log(prop);
                            var linePrice = parseFloat(prop.line_price/100).toFixed(2);
                            $("#total_"+(id.replace(":", "\\:"))).text(symbol+linePrice);
                        }

                        //update subtotal
                        $(".cart__subtotal").text(symbol+parseFloat(total/100).toFixed(2));
                    }
                });

                //update cart count
                $(".cart_count").text(number);


                active_click=true;
            }).error(function() {
                console.log("error");
            });
        }
    });
};

burgon.requestTradeAccount = function() {
  // console.log('reqaccount:: test');
  setTimeout(function() {

    $('.esc--form').fadeIn('slow', function() {});

    // Radio buttons
    $('.esc--field-wrap.radio').addClass('form-block');
    $('.esc--field-wrap.radio').each(function(index, el) {
      $(this).append('<p class="esc--radio-buttons"></p>');
      $(this).find('div').addClass('esc--single-radio-button').detach().appendTo($(this).find('.esc--radio-buttons'));
    });
    $('.esc--single-radio-button').each(function(index, el) {
      $(this).contents().eq(1).remove();
      var button_value = $(this).find('input').attr('value');
      var button_id = $(this).find('input').attr('id');
      $(this).append('<label for="' + button_id + '">' + button_value + '</value>');
      if (button_value == 'Other') {
        $(this).addClass('esc--custom-field').append('<input type="text" class="esc--custom-other" placeholder="Other business">');
      }
    });
    $('.esc--custom-other').on('input', function() {
      $('.esc--custom-field').find('input').val($(this).val());
    });

    // Checkbox field
    var esc_checkbox = $('.esc--field-wrap.checkbox');
    esc_checkbox.wrapInner('<div class="esc--single-checkbox"></div>');
    esc_checkbox.prepend('<div class="esc--label">Please tick here if you would like to</div>');
    $('.esc--single-checkbox input').prop('checked', false);

    // Countries dropdown
    var list_countries = $('.esc--country-list');
    $('.esc--field-wrap.select').each(function(index, el) {
      var label_name = $(this).find('label').text();
      if (label_name == 'Country:*') {
        var countries_dropdown = $(this).find('select');
        countries_dropdown.empty();
        countries_dropdown.append(list_countries.html());
      }
    });

    // Submit button
    $('.esc--btn-submit').addClass('btn-round btn-primary').val('Request trade account');

    $('.esc--btn-submit').on('click', function(event) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      // return false;
    });

  }, 2000);
}

$(burgon.init);
